<template>
  <div class="btn-gis" @click="toGisPage">
    <img src="@/assets/img/btn-gis.png">
  </div>
</template>

<script>
export default {
  props: {
    gisurl: String
  },
  methods: {
    toGisPage() {
      if (this.gisurl) {
        location.href = this.gisurl;
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/base";
.btn-gis {
  display: inline-block;
  width: 2rem;
  height: 2rem;

  @include img-fluid;
}
</style>
